"use client";

import { Checkbox } from "@/components/ui/checkbox";
import { authTestIds } from "@/lib/data-test-ids/components.data-test-ids";

export function SharedDeviceChoice({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <label className="flex cursor-pointer items-start gap-3 rounded-lg border border-line-faint bg-surface-subtle px-3.5 py-3">
      <Checkbox
        className="mt-0.5 bg-card"
        checked={checked}
        onCheckedChange={(value) => onChange(value === true)}
        data-testid={authTestIds.SHARED_DEVICE_CHECKBOX}
      />
      <span className="min-w-0">
        <span className="block text-sm text-foreground">
          Other people use this computer
        </span>
        <span className="block text-xs text-ink-subtle">
          Shared, front-office, or school computer. Helps us protect your
          account on devices you don&apos;t control.
        </span>
      </span>
    </label>
  );
}
